import { jsx as e, jsxs as s } from "react/jsx-runtime";
import { SkeletonBlock as n, SkeletonText as o, Text as a } from "@zapier/design-system";
const i = "_zapBreakdownWrapper_17e5p_1", p = "_zapBreakdownContainer_17e5p_15", r = "_title_17e5p_28", d = "_servicesArea_17e5p_33", l = "_detailsLabel_17e5p_37", c = "_twoStepsBottom_17e5p_41", _ = "_twoStepsTop_17e5p_42", S = "_threeOrMoreSteps_17e5p_43", h = "_stepServiceIcon_17e5p_67", k = "_stepLabel_17e5p_71", v = "_hiddenStepsContainer_17e5p_76", w = "_hiddenSteps_17e5p_76", m = "_serviceIconsSkeleton_17e5p_101", B = "_skeletonStepsContainer_17e5p_106", z = "_skeletonStep_17e5p_106", t = {
  zapBreakdownWrapper: i,
  zapBreakdownContainer: p,
  title: r,
  servicesArea: d,
  detailsLabel: l,
  twoStepsBottom: c,
  twoStepsTop: _,
  threeOrMoreSteps: S,
  stepServiceIcon: h,
  stepLabel: k,
  hiddenStepsContainer: v,
  hiddenSteps: w,
  serviceIconsSkeleton: m,
  skeletonStepsContainer: B,
  skeletonStep: z
};
var N = function() {
  return /* @__PURE__ */ e("div", { className: t.zapBreakdownWrapper, "data-testid": "zap-breakdown", children: /* @__PURE__ */ s("div", { className: t.zapBreakdownContainer, children: [
    /* @__PURE__ */ s("div", { className: t.title, children: [
      /* @__PURE__ */ e("div", { className: t.servicesArea, children: /* @__PURE__ */ s("div", { className: t.serviceIconsSkeleton, children: [
        /* @__PURE__ */ e(n, { width: 36, height: 36 }),
        /* @__PURE__ */ e(n, { width: 36, height: 36 })
      ] }) }),
      /* @__PURE__ */ e(o, { lines: 1, size: "body" })
    ] }),
    /* @__PURE__ */ e("div", { className: t.detailsLabel, children: /* @__PURE__ */ e(a, { type: "Body4", children: "Zap details:" }) }),
    /* @__PURE__ */ s("div", { className: t.skeletonStepsContainer, children: [
      /* @__PURE__ */ s("div", { className: t.skeletonStep, children: [
        /* @__PURE__ */ e(n, { width: 24, height: 24 }),
        /* @__PURE__ */ e(o, { lines: 1, size: "body" })
      ] }),
      /* @__PURE__ */ s("div", { className: t.skeletonStep, children: [
        /* @__PURE__ */ e(n, { width: 24, height: 24 }),
        /* @__PURE__ */ e(o, { lines: 1, size: "body" })
      ] })
    ] })
  ] }) });
};
export {
  N as Z,
  t as s
};
//# sourceMappingURL=ZapBreakdownSkeleton-BAGrHqZG.mjs.map
